import React from "react";
import { useTranslation } from "react-i18next";

import { WarningIcon } from "fe-shared/src/components/Icons";
import { PickupRequestCompany } from "../../types";

import RequestCompanyBlock from "../RequestCompanyBlock";

import styles from "./RequestHaulerBlock.module.scss";

interface Props {
  targetCompanyId: number | null;
  company: PickupRequestCompany | null | undefined;
  editable?: boolean;
  participantLinkTo?: (companyId: number) => string;
}

const RequestHaulerBlock = (props: Props) => {
  const { targetCompanyId, company, editable, participantLinkTo } = props;
  const { t } = useTranslation();

  if (!targetCompanyId) {
    return (
      <div className={styles.warning} data-editable={editable}>
        <WarningIcon width="18" height="18" />
        <div className={styles.warningText}>
          <span>{t("pickupRequests.grid.warnings.noHauler")}</span>
          <span className={styles.warningBody}>
            {t("pickupRequests.details.noHaulerDescription")}
          </span>
        </div>
      </div>
    );
  }

  return (
    <RequestCompanyBlock
      title={t("pickupRequests.form.haulerLabel")}
      company={company}
      editable={editable}
      participantLinkTo={participantLinkTo}
    />
  );
};

export default RequestHaulerBlock;
